import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import '../css/DataStatisticsCard.css';

const DataStatisticsCard = ({ dataList, customStyle = {} }) => {
    // 沿用與 Header 相同的判斷邏輯 (中英文切換)
    const location = useLocation();
    const isEnglish = location.pathname.startsWith('/en');

    return (
        <div className="ratio-info-card-dynamic" style={customStyle}>
            {dataList.map((item, index) => (
                <Fragment key={index}>
                    {/* 數據盒 */}
                    <div className='ratio-text-box'>
                        {isEnglish ? (
                            <>
                                <div className="content-en">{item.titleEn}</div>
                                <div className="ratio-number">
                                    {item.symbol && <span className="symbol">{item.symbol}</span>}
                                    <span className="value">{item.value}</span>
                                    <span className="unit">
                                        <span className="content-en">{item.unitEn ?? item.unit}</span>
                                    </span>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="content-ch">{item.titleCh}</div>
                                <div className="ratio-number">
                                    {item.symbol && <span className="symbol">{item.symbol}</span>}
                                    <span className="value">{item.value}</span>
                                    <span className="unit">
                                        <span className="content-ch">{item.unitCh ?? item.unit}</span>
                                    </span>
                                </div>
                            </>
                        )}
                    </div>

                    {/* 如果不是最後一個項目，就顯示分割線 */}
                    {index < dataList.length - 1 && <div className="divider-line"></div>}
                </Fragment>
            ))}
        </div>
    );
};

export default DataStatisticsCard;